import icon from "@/assets/icons/plans_icon.svg";
import GlassContainer from "@/shared/components/glasscontainer";

interface PlanesSidebarProps {
  totalPlans: number;
  loading: boolean;
}

export function PlanesSidebar({ totalPlans, loading }: PlanesSidebarProps) {
  return (
    <aside className="w-80 shrink-0 px-8 pb-20 flex flex-col items-center justify-center overflow-y-auto min-h-screen">
      <img src={icon} className="size-68" />
      <h1 className="text-2xl font-bold tracking-tight text-foreground mb-3 text-center">
        Panel de planes
      </h1>
      <p className="text-sm text-foreground/50 leading-relaxed text-center">
        Administra los planes de suscripción disponibles para las cuentas.
        Configura precios, periodos y condiciones adicionales desde aquí.
      </p>
      <div className="mt-8 space-y-3">
        <GlassContainer className="flex items-center justify-center gap-x-5 p-4">
          <p className="text-xs font-semibold text-foreground/60 uppercase tracking-widest mb-1">
            Total de planes
          </p>
          <p className="text-3xl font-bold text-foreground">
            {loading ? "—" : totalPlans}
          </p>
        </GlassContainer>
      </div>
    </aside>
  );
}
